/**
 * Locale Store
 * Standalone from auth-store since the language choice must be available
 * pre-login (e.g. on LoginPage).
 */

import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Locale = "sv" | "en";

interface LocaleState {
  language: Locale;
  setLanguage: (language: Locale) => void;
}

/**
 * Default locale for first-time visitors (no persisted preference yet):
 * Swedish if the browser reports a Swedish locale, English otherwise.
 */
export function detectDefaultLocale(): Locale {
  if (typeof navigator === "undefined") return "en";
  const lang = navigator.language || "";
  return lang.toLowerCase().startsWith("sv") ? "sv" : "en";
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      language: detectDefaultLocale(),
      setLanguage: (language) => set({ language }),
    }),
    {
      name: "seaslot-locale",
    },
  ),
);
